import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
	.set('Evaluacion', new Immutable.Map({}))
	.set('SaveCriterio', new Immutable.Map({}))
	.set('SaveObs', new Immutable.Map({}))

/* Types */
export const ACTION_GET_EVALUATION_PERFORMANCE = 'ACTION_GET_EVALUATION_PERFORMANCE'
export const ACTION_UPDATE_CRITERIO_EVALUATION = 'ACTION_UPDATE_CRITERIO_EVALUATION'
export const ACTION_UPDATE_OBS_EVALUATION = 'ACTION_UPDATE_OBS_EVALUATION'

/* Reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case ACTION_GET_EVALUATION_PERFORMANCE:
			return state.set('Evaluacion', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_CRITERIO_EVALUATION:
			return state.set('SaveCriterio', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_OBS_EVALUATION:
			return state.set('SaveObs', new Immutable.Map(action.Obj))
		default:
			return state
	}
}

/* Action Creators */
export const getEvaluationPerformance = form => {
	return dispatch => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getEvaluationPerformance',
			method: 'POST',
			data: { ...form },
			headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_EVALUATION_PERFORMANCE, Obj: response.data })
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateCriterioEvaluation = form => {
	let tmp = {
		"usuario": sessionStorage.uid,
		"idCriterio": form.idCriterio,
		"idDonataria": form.idDonataria,
		"idCorrida": form.idCorrida,
		"idNivelCumplimiento": form.idNivelCumplimiento || null,
		"observaciones": form.observacion || ""
	}
	return dispatch => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateCriterioEvaluation',
			method: 'POST',
			data: { ...tmp },
			headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_CRITERIO_EVALUATION, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateObsEvaluation = form => {
	let tmp = {
		"usuario": sessionStorage.uid,
		"idEvaluacion": form.idEvaluacion,
		"idDonataria": form.idDonataria,
		"idCorrida": form.idCorrida,
		"observacion": form.recomendaciones || ""
	}
	return dispatch => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateObsEvaluation',
			method: 'POST',
			data: { ...tmp },
			headers: Object.assign({ Authorization: sessionStorage.access_token, uid: sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_OBS_EVALUATION, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Evaluation/EvaluationPerformance.js